import type { ApolloError } from "apollo-server-errors";

export const GQLERROR_FORBIDDEN = "FORBIDDEN";
export const GQLERROR_TOKEN_EXPIRED = "TOKEN_EXPIRED";
export const GQLERROR_NOT_FOUND = "GQLERROR_NOT_FOUND";

export function getApolloErrorCode(err: ApolloError): string | undefined {
    return err.graphQLErrors[0]?.extensions?.code;
}
